module.exports = __webpack_public_path__ + "img/page.6ae50fd1.png";